<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">what's on</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">what's on</el-menu-item>
          </el-menu>
          <!-- 展出时间 -->
          <div class="zcsj">
            Exhibit Hours
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 2, 2026, 9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 3, 2026, 9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 4, 2026, 9:00am-4:00pm
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              (Last admission 1 hour before closing)
            </div>
          </div>
        </el-col>
        <el-col :span="18">

          <div >
           <img style="width:100%" src="../../assets/index/附件八/1.jpg" alt="">
           <img style="width:100%" src="../../assets/index/附件八/2.jpg" alt="">
           <img style="width:100%" src="../../assets/index/附件八/3.jpg" alt="">
          </div>

        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Gyzh',
  data () {
    return {
      menuName: '联系我们',
      pageNum: '1'
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/home/Header1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.midbgi {
  background-image: url('../../assets/home/renwu.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: 40% 100%;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
p {
  text-align: center;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.jt {
  /* display: flex; */
  margin: 0 auto;
  text-align: center;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}

.zbzs {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/caidaneng/lxwm.vue